import CustomModalWrapper from "components/Common/CustomModalWrapper";
import { PlusOutlined } from "@ant-design/icons";
import { message, Upload, Input } from "antd";
import { useEffect, useState } from "react";
import { Button } from "antd-mobile";
import styles from "./chatInput.module.css";

import useWindowWidth from "hooks/useWindowWidth";

import cuid from "cuid";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { useChatContext } from "context/ChatContext";

const { TextArea } = Input;

const SendMedia = ({ openModal, setOpenModal }) => {
  return (
    <CustomModalWrapper
      openModal={openModal}
      setOpenModal={setOpenModal}
      heading="Send Image / Video">
      <SendMediaComponent setOpenModal={setOpenModal} />
    </CustomModalWrapper>
  );
};

export default SendMedia;

const SendMediaComponent = ({ setOpenModal }) => {
  const [isUploaded, setIsUploaded] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [messageL, setMessageL] = useState("");
  const [mediaName, setMediaName] = useState("");
  const { handleMessageSend } = useChatContext();
  const [type, setType] = useState("image");
  const [isUploading, setIsUploading] = useState(false);
  const isDesktop = useWindowWidth();

  const handleSendMessage = () => {
    let val = "media";
    if (messageL) {
      val = messageL;
    }
    handleMessageSend(val, "media", imageUrl, type, mediaName);
    setOpenModal(false);
    setMessageL("");
    setImageUrl("");
    setIsUploaded(false);
    setMediaName("");
  };

  const props = {
    name: "file",
    customRequest: (options) => {
      const { onSuccess, file, onProgress, onError } = options;
      setIsUploading(true);
      const storage = getStorage();
      const fileName = file.name;
      const fileType = file.type.split("/")[0];

      const storageRef = ref(
        storage,
        `/drafts/${fileName.slice(0, 10) + cuid()}`
      );
      const uploadTask = uploadBytesResumable(storageRef, file, {
        contentDisposition: "",
      });
      uploadTask.on(
        "state_changed",
        (snapshot) => {},
        (error) => {
          setIsUploading(false);
          onError && onError(error);
        },
        async () => {
          const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
          onSuccess && onSuccess(downloadURL);
          setMediaName(fileName);
          setImageUrl(downloadURL);
          setType(fileType);
          setIsUploading(false);
        }
      );
    },

    onChange(info) {
      if (info.file.status !== "uploading") {
      }
      if (info.file.status === "done") {
        setIsUploaded(true);
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };
  return (
    <div
      style={
        isDesktop
          ? {
              display: "grid",
              height: "100%",
              width: "100%",
              alignItems: "flex-end",
            }
          : {}
      }>
      <div
        style={
          !isDesktop
            ? {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }
            : { width: 102, margin: "0 auto" }
        }>
        <Upload
          {...props}
          accept="image/*,video/*"
          maxCount={1}
          listType="picture-card"
          onRemove={(e) => setIsUploaded(false)}>
          {!isUploaded && !isUploading && uploadButton}
        </Upload>
      </div>
      <div className={isDesktop ? styles.containerDesktop : styles.container}>
        <TextArea
          placeholder="Add a caption"
          style={{ borderRadius: "8px" }}
          value={messageL}
          defaultValue={""}
          onChange={(event) => setMessageL(event.target.value)}
          onBlur={() => null}
          autoSize={{ minRows: 1, maxRows: 2 }}
        />

        <Button
          style={{}}
          type="primary"
          size="md"
          color="primary"
          onTouchEnd={() => handleSendMessage()}
          onClick={() => handleSendMessage()}
          disabled={!isUploaded}>
          Send
        </Button>
      </div>
    </div>
  );
};

const uploadButton = (
  <div>
    <PlusOutlined />
    <div
      style={{
        marginTop: 8,
      }}>
      Upload
    </div>
  </div>
);
